import { createGlobalStyle } from "styled-components"
import reset from "styled-reset"
import selfModernWoff from "../resources/fonts/bretagne_self-modern_text_web.woff"
import selfModernWoff2 from "../resources/fonts/bretagne_self-modern_text_web.woff2"
import helveticaNeueWoff from "../resources/fonts/HelveticaNeue.woff"
import helveticaNeueWoff2 from "../resources/fonts/HelveticaNeue.woff2"
import helveticaNeueLightWoff from "../resources/fonts/HelveticaNeue-Light.woff"
import helveticaNeueLightWoff2 from "../resources/fonts/HelveticaNeue-Light.woff2"
import helveticaNeueMediumWoff from "../resources/fonts/HelveticaNeue-Medium.woff"
import helveticaNeueMediumWoff2 from "../resources/fonts/HelveticaNeue-Medium.woff2"
import helveticaNeueCondensedBoldWoff from "../resources/fonts/HelveticaNeue-CondensedBold.woff"
import helveticaNeueCondensedBoldWoff2 from "../resources/fonts/HelveticaNeue-CondensedBold.woff2"
import helveticaNeueCondensedMediumWoff from "../resources/fonts/HelveticaLT67MediumCondensed.woff"
import helveticaNeueCondensedMediumWoff2 from "../resources/fonts/HelveticaLT67MediumCondensed.woff2"
import americanaRegularWoff from "../resources/fonts/Americana-Font-Regular.woff"
import americanaRegularWoff2 from "../resources/fonts/Americana-Font-Regular.woff2"
import americanaItalicWoff from "../resources/fonts/AmericanaBT-Italic.woff"
import americanaItalicWoff2 from "../resources/fonts/AmericanaBT-Italic.woff2"
import ttnormsProBoldWoff2 from "../resources/fonts/TTNormsProBold.woff2"
import ttnormsProRegularWoff2 from "../resources/fonts/TTNormsProRegular.woff2"
import americanaBtBoldWoff2 from "../resources/fonts/americanabt_bold.woff2"
import americanaBtRomanWoff2 from "../resources/fonts/americanabt_roman.woff2"

import colors from "./colors"
import fonts from "./fonts"

const fontFace = (fontFamily, woff, woff2) => {
  return `
      @font-face {
          font-family: '${fontFamily}';
          src: url(${woff2}) format('woff2'),
          url(${woff}) format('woff');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
      }
    `
}

const GlobalStyle = createGlobalStyle`
    ${reset}
    ${fontFace("Self Modern", selfModernWoff, selfModernWoff2)}
    ${fontFace("Helvetica Neue", helveticaNeueWoff, helveticaNeueWoff2)}
    ${fontFace(
      "Helvetica Neue Light",
      helveticaNeueLightWoff,
      helveticaNeueLightWoff2
    )}
    ${fontFace(
      "Helvetica Neue Medium",
      helveticaNeueMediumWoff,
      helveticaNeueMediumWoff2
    )}
    ${fontFace(
      "Helvetica Neue Condensed Medium",
      helveticaNeueCondensedMediumWoff,
      helveticaNeueCondensedMediumWoff2
    )}
    ${fontFace(
      "Helvetica Neue Condensed Bold",
      helveticaNeueCondensedBoldWoff,
      helveticaNeueCondensedBoldWoff2
    )}
    ${fontFace("Americana", americanaRegularWoff, americanaRegularWoff2)}
    ${fontFace("Americana Italic", americanaItalicWoff, americanaItalicWoff2)}
    ${fontFace("TTNormsPro Bold", ttnormsProBoldWoff2, ttnormsProBoldWoff2)}
    ${fontFace("TTNormsPro Regular", ttnormsProRegularWoff2, ttnormsProRegularWoff2)}
    ${fontFace("AmericanaBt Bold", americanaBtBoldWoff2, americanaBtBoldWoff2)}
    ${fontFace("AmericanaBt Roman", americanaBtRomanWoff2, americanaBtRomanWoff2)}

    body {
        -webkit-tap-highlight-color: transparent;
        position: relative;
        background: ${colors.beige};
        ${fonts.helveticaNeueLight};
        font-size: 16px;
        line-height: 24px;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    h1,
    h2, 
    h3 {
      display: block;
      letter-spacing: 0;
      color: ${colors.black};        
      ${fonts.selfModern};
    }

    /* Alma Widget */

    ._ocM9x {
      ._1HqCO ._3B8wx{
        color: ${colors.black} !important;
      }

      ._1l2Oa>button._3rue7 {
        background: ${colors.lightGreen};
      }

      ._1Z9wr {
        background-color: ${colors.borderGrey};
      }

      ._2Nmkl {
        background: ${colors.lightGreen};
      }

      ._xW3wt {
        path {
          fill: ${colors.black};
        }
      }
    }

    iframe#chat-button {
      left: unset;
      right: 22px;
    }
    @media (min-width: 768px) {
      iframe#chat-window {
        left: unset;
        right: 0px;
      }
    }

    div#ot-sdk-btn-floating.ot-floating-button {
      display: none;
    }

    div#onetrust-banner-sdk:focus {
      outline-offset: -1px;
    }
`

export default GlobalStyle
